import React from "react";
import EdiText from "react-editext";

const EditableNameCell = ({ value, onSave,setNameModal,setUserIds,rowData, canEdit = true }) => {
  const [error, setError] = React.useState("");
  const [inputValue, setInputValue] = React.useState(value || "-");
  const [originalValue, setOriginalValue] = React.useState(value || "-");

  React.useEffect(() => {
    setInputValue(value || "-");
    setOriginalValue(value || "-");
  }, [value]);

  const validate = (val) => {
    const trimmed = val.trim();

    if (!trimmed) {
      setError("Name is required");
      return false;
    }
    if (trimmed.length < 3) {
      setError("Name should be between 3 to 20 characters");
      return false;
    }
    if (trimmed.length > 20) {
      setError("Name should be between 3 to 20 characters");
      return false;
    }
    if (!/^[A-Za-z\s]+$/.test(trimmed)) {
      setError("Name should be alphabetic characters only.");
      return false;
    }

    setError("");
    return true;
  };

  const handleEditClick = (e) => {
    setUserIds({userId: rowData?.userId,rowData:rowData, to: rowData?.email})
    setNameModal(true)
  };

    if (!canEdit) {
        return <div className="column-data user-edit">{inputValue}</div>;
    }

    return (
        <div className="column-data user-edit">
            <EdiText
                type="text"
                value={inputValue}
                onSave={(val) => {
                    if (validate(val)) {
                        setInputValue(val);
                        setOriginalValue(val);
                        onSave(val);
                    }
                }}
                onCancel={() => {
                    setInputValue(originalValue);
                    setError("");
                }}
                saveButtonClassName={`nameedit-btn save ${error ? "disabled" : ""}`}
                editButtonClassName="nameedit-btn edit"
                cancelButtonClassName="nameedit-btn cancel"
                saveButtonContent={<i className="pi pi-check" />}
                editButtonContent={
                    (process.env.REACT_APP_NAME === "esimcrew" || process.env.REACT_APP_NAME === "elefone" || process.env.REACT_APP_NAME === "briant") && !!setNameModal ? (
                        <span
                            className="nameedit-btn edit"
                            onClick={(e) => {
                                e.stopPropagation(); // prevent EdiText from triggering directly
                                handleEditClick();
                            }}
                        >
                            <i className="pi pi-pencil" />
                        </span>
                    ) : (
                        <i className="pi pi-pencil" />
                    )
                }
                cancelButtonContent={<i className="pi pi-times" />}
                viewContainerClassName="custom-view-container"
                editContainerClassName="custom-edit-container"
                inputProps={{
                    value: inputValue,
                    onChange: (e) => {
                        setInputValue(e.target.value);
                        validate(e.target.value);
                    },
                    onBlur: (e) => validate(e.target.value),
                }}
            />
            {error && (
                <span className="customers-error">
                    {error}
                </span>
            )}
            <style>
                {`
            .nameedit-btn.save.disabled {
            opacity: 0.5;
            pointer-events: none;
            }
        `}
            </style>
        </div>
    );
};

export default EditableNameCell;
